import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
// import Modal from 'react-responsive-modal';
import Modal from 'react-modal';
import 'react-responsive-modal/styles.css';
import CreatePaymentIntentApi from '../../api/create-payment-intent';
import StripePayment from '../Stripe-Payment/Stripe-Payment';
import useAllCharges from '../../hooks/AllCharge';
import Konsole from '../../utils/konsole/Konsole';
import { ErrorToast } from '../ToastComponent/ErrorToast';
import PaymentSkelton from '../../skelton/PaymentSkelton';

interface customeType {
  openPayment: boolean;
  onClosePaymentModal: any;
  stripeConnectId?: any;
}
const appearance: any = {
  theme: 'stripe',

  rules: {
    
    '.Tab': {
      border: '1px solid #E0E6EB',
      boxShadow:
        '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)',
    },

    '.Tab:hover': {
      color: 'var(--colorText)',
    },

    // '.Tab--selected': {
    //   // borderColor: '#E0E6EB',
    //   // boxShadow:
    //   //   '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02), 0 0 0 2px var(--colorPrimary)',
    // },
    '.Tab--selected': {
  border: '1px solid var(--colorPrimary)',
}
,

    '.Input--invalid': {
      boxShadow:
        '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 2px var(--colorDanger)',
    },
  },
};
const PaymentModal = ({
  openPayment,
  onClosePaymentModal,
  stripeConnectId,
}: customeType) => {
  const navigate = useNavigate();

  const [taxes, discount, service_charge, remaining_amount, totalPrice] =
    useAllCharges();
  Konsole.log(taxes, discount, service_charge, remaining_amount, totalPrice);
  const reduxStoreData = useSelector((state: any) => state);
  const {
    store: { selectedStore },
    cartData: { commissionFee, deliveryCharge, discountAmount },
    userData: {
      user: {
        first_name,
        last_name,
        iso_code,
        phone,
        phone_code,
        // user_id,
        email,
      },
    },
  } = reduxStoreData;

  // console.log('storestorestore',selectedStore)
  const stripe = loadStripe(process.env.REACT_APP_PUBLIC_API_KEY || '', {
    stripeAccount: stripeConnectId, //'acct_1QaFPfRvf9mwPzG8' //stripeConnectId,
  });

  // console.log('reduxStoreDatareduxStoreDataasdf', reduxStoreData)

  const [secretDetail, setSecretDetail] = useState<any>({});
  Konsole.log(
    'totalPriceasdf',
    deliveryCharge,
    discountAmount,
    totalPrice,
    last_name,
    iso_code,
    phone_code
  );

  useEffect(() => {
    let storeId = sessionStorage.getItem('store-id') || '';
    if (!storeId) {
      ErrorToast('Something went wrong');
      setTimeout(() => {
        navigate('/');
      }, 1000);
    }
  }, []);
  useEffect(() => {
    if (totalPrice > 0) {
      getPaymentElementId();
    }
  }, [totalPrice]);
  async function getPaymentElementId() {
    try {
      const { data } = await CreatePaymentIntentApi({
        totalPrice: totalPrice || 0,
        commission: commissionFee || 0,
        email: email,
        first_name: first_name,
        phone: phone,
        user_id: selectedStore?.user_id,
      });
      setSecretDetail(data?.secret_key || {});
      sessionStorage.setItem('secret_key_intent', data?.secret_key?.id);
    } catch (error) {
      Konsole.log('error', error);
      setSecretDetail({});
    }
  }

  return (
    <Modal

      className="payment-modal-scroll new-modal-react w-auto bg-white p-0 md:h-[35rem] md:!rounded-md !rounded-none  scroll-hidden "
      onRequestClose={onClosePaymentModal}
      isOpen={openPayment}
      closeTimeoutMS={300}
            overlayClassName="modal-overlay"


      // open={openPayment}
      // onClose={onClosePaymentModal}
      // center
      // closeOnOverlayClick={false}
      // classNames={{
      //   overlay: 'customOverlay',
      //   modal: 'modalMd scroll-hidden',
      //   closeIcon: 'modal-close',
      // }}
    >

      <button className="new-close-btn" onClick={onClosePaymentModal}>
            <svg className="modal-close" width="28" height="28" viewBox="0 0 36 36" data-testid="close-icon"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path></svg>
          </button>
      {Object.keys(secretDetail)?.length && secretDetail ? (
        <Elements
          stripe={stripe}
          options={{
            clientSecret: secretDetail?.client_secret,
            appearance: appearance,
          }}
        >
          <StripePayment stripeConnectedId={stripeConnectId} />
        </Elements>
      ) : (
        <PaymentSkelton />
        // <div className="flex h-screen items-center"><h1 className="mx-auto">Loading.....</h1></div>
      )}
    </Modal>
  );
};
export default PaymentModal;
